import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/mis-locales")({
  beforeLoad: () => {
    throw redirect({ href: "/herramientas/mis-locales", statusCode: 301 });
  },
});
